import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Services() {
  const services = [{
    image: 'https://cdn.magicpatterns.com/uploads/bgX9bG8RQp6MamQx6jMAND/daniel-romero-aiUAxBNe3Xk-unsplash.jpg',
    title: 'Free Cellular Phones',
    desc: 'Stay connected with a free smartphone through Lifeline. No hidden fees, no surprises.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/7EXdujL8UJY4PK1w2cBReD/kelly-sikkema-iVNkiqd_ZLg-unsplash.jpg',
    title: 'Free Tablets & Service',
    desc: 'Qualifying households receive a free tablet and service. Just a one-time $23 activation fee.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/oFDWFN1qPNPJPLBMtqfQV1/scott-rodgerson-PSpf_XgOM5w-unsplash.jpg',
    title: 'Free Home Internet',
    desc: 'Reliable home internet at no cost for eligible families. Stay online for school, work, and beyond.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/gyKkQeUVRhHPMw8UDdwjXe/online-marketing-hIgeoQjS_iE-unsplash.jpg',
    title: 'Free Healthcare Insurance',
    desc: 'Access free healthcare insurance options for you and your dependents.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/rUcQ7QNsWT66oaVfVNMfbR/james-yarema-G3q7mxXkP-M-unsplash.jpg',
    title: 'Discounted Cell Phone Service',
    desc: 'Lower your monthly bill with our discounted plans designed for working families.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="services" className="bg-white py-16 md:py-24" data-id="element-152">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-154">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-brand-gold font-bold tracking-widest uppercase text-sm mb-4" data-id="element-155">
            What We Offer
          </motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-brand-black text-[32px] md:text-[42px] leading-tight font-serif mb-6" data-id="element-156">
            Built to Empower the Underserved
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-brand-charcoal/80 text-base md:text-lg" data-id="element-157">
            Five core services designed to keep families connected, healthy, and
            supported. If you qualify, you pay nothing.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-158">
          {services.map((service, idx) => <motion.div key={idx} variants={itemVariants} className="bg-white rounded-xl overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.05)] border border-gray-100 hover:border-t-4 hover:border-t-brand-gold transition-all duration-300 flex flex-col h-full group" data-id="element-159">
              <div className="relative h-48 overflow-hidden" data-id="element-160">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-161" />
                <div data-service={service.title} className="absolute inset-0 bg-brand-black/10 group-hover:bg-brand-gold/10 transition-colors duration-300" data-id="element-162" />
              </div>
              <div className="p-8 flex flex-col flex-grow" data-id="element-163">
                <h3 className="text-xl font-serif font-bold text-brand-black mb-3" data-id="element-164">
                  {service.title}
                </h3>
                <p className="text-brand-charcoal/70 mb-8 flex-grow" data-id="element-165">
                  {service.desc}
                </p>
                <a href="#qualify" className="inline-flex items-center gap-2 text-brand-gold font-bold hover:text-yellow-600 transition-colors mt-auto min-h-[44px]" data-id="element-166">
                  Book Now <ArrowRight size={18} data-id="element-167" />
                </a>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}